import Commons from '../../Services/Common/Common';

/**
 * 공통 조회 성공 처리 함수
 * - rows가 비어있으면 빈 배열 반환
 * - dateKey 옵션이 있으면 해당 필드를 YYYY-MM-DD 형태로 잘라서 가공
 * - Commons.InsertNumber(rows)로 번호/순번(no 등) 부여(그리드 표시용)
 * - onSuccess 콜백이 있으면 가공된 데이터(processedData)와 원본 response 전달 - 데이터가 있을 때만 호출가능
 *
 * 사용 형태(2가지 지원)
 * - handleQuerySuccess(res, (rows) => { ... })                // 함수만 넘기기
 * - handleQuerySuccess(res, { onSuccess, dateKey, ... })      // 옵션 객체 넘기기
 */
export const handleQuerySuccess = (response, successCallback) => {
  const opts =
    typeof successCallback === 'function'
      ? { onSuccess: successCallback }
      : successCallback || {};

  const {
    onSuccess,
    // 날짜 가공하는 경우 사용
    dateKey,
  } = opts;

  const { data } = response || {};
  const rows = Array.isArray(data) ? data : [];

  if (dateKey) {
    rows.forEach((item) => {
      const v = item?.[dateKey];
      item[dateKey] = v ? String(v).substr(0, 10) : '';
    });
  }

  const processedData = Commons.InsertNumber(rows);

  //  가공 후에 콜백함수 실행
  if (onSuccess) onSuccess(rows.length ? processedData : [], response);

  return rows.length ? processedData : [];
};
